import Button from "@/shared/ui/button/Button";
import { CartItem } from "@/domains/shop/constants/cartItem";

type Props = {
  cartItem: CartItem;
  handleIncrement: (id: number) => void;
  handleDecrement: (id: number) => void;
};

export default function ShopCartItemsControls({
  cartItem,
  handleIncrement,
  handleDecrement,
}: Props) {
  return (
    <div className="flex grow w-[8.75rem] h-10.5 p-1 bg-dark-900 rounded-xl">
      <Button
        className="group relative size-8.5 rounded-xl"
        icon
        onClick={() => handleDecrement(cartItem.id)}
        variant="soft"
        color="gray"
      >
        <span className="absolute size-full top-0 left-0 bg-gradient-accent rounded-xl opacity-0 transition-all ease-in-out duration-200 group-hover:opacity-100" />
        <span className="relative z-1 w-2.5 h-0.5 bg-white" />
      </Button>
      <p className="flex justify-center items-center grow text-14 font-bold">{cartItem.count}</p>
      <Button
        className="group relative size-8.5 rounded-xl"
        icon
        onClick={() => handleIncrement(cartItem.id)}
        variant="soft"
        color="gray"
      >
        <span className="absolute size-full top-0 left-0 bg-gradient-accent rounded-xl opacity-0 transition-all ease-in-out duration-200 group-hover:opacity-100" />
        <span className="relative z-1 w-2.5 h-0.5 bg-white">
          <span className="absolute top-1/2 left-1/2 w-0.5 h-2.5 bg-white -translate-x-1/2 -translate-y-1/2" />
        </span>
      </Button>
    </div>
  );
}
